(() => {
  const root = document.querySelector('[data-eye-page]');
  if (!root) return;
  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => [...scope.querySelectorAll(selector)];

  const offers = $$('[data-eye-offer]');
  const addButton = $('[data-eye-add]');
  const mobileAdd = $('[data-eye-mobile-add]');
  const mobilePrice = $('[data-eye-mobile-price]');
  const cart = $('[data-eye-cart]');
  const backdrop = $('[data-eye-cart-backdrop]');
  const checkout = $('[data-eye-checkout]');
  const error = $('[data-eye-cart-error]');
  let selected = offers.find((offer) => offer.classList.contains('is-active')) || offers[0];

  function formatPrice(value) { return `$${Number(value).toFixed(2)}`; }
  function syncOffer(offer) {
    selected = offer;
    offers.forEach((item) => {
      const active = item === offer;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-checked', String(active));
    });
    const price = formatPrice(offer.dataset.price);
    addButton.textContent = `TRY IT RISK-FREE — ${price}`;
    mobilePrice.textContent = price;
    $('[data-eye-cart-offer]').textContent = offer.dataset.name;
    $('[data-eye-cart-quantity]').textContent = `${offer.dataset.quantity} ${Number(offer.dataset.quantity) === 1 ? 'gel' : 'gels'}`;
    $('[data-eye-cart-price]').textContent = price;
    $('[data-eye-cart-total]').textContent = `${price} USD`;
    if (error) error.hidden = true;
  }
  offers.forEach((offer) => offer.addEventListener('click', () => syncOffer(offer)));
  syncOffer(selected);

  function openCart() {
    $('[data-eye-bag-count]').textContent = '1';
    cart.classList.add('is-open');
    cart.setAttribute('aria-hidden', 'false');
    backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cart.classList.remove('is-open');
    cart.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    document.body.style.overflow = '';
  }
  addButton.addEventListener('click', openCart);
  mobileAdd.addEventListener('click', openCart);
  $$('[data-eye-open-cart]').forEach((button) => button.addEventListener('click', openCart));
  $$('[data-eye-close-cart]').forEach((button) => button.addEventListener('click', closeCart));
  backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  checkout.addEventListener('click', () => {
    const variantId = selected?.dataset.variantId?.trim() || '';
    if (!/^\d+$/.test(variantId)) {
      error.hidden = false;
      return;
    }
    checkout.disabled = true;
    checkout.textContent = 'OPENING SECURE CHECKOUT…';
    const store = root.dataset.checkoutStore;
    const url = new URL(`/cart/${variantId}:1`, store);
    url.searchParams.set('currency', 'USD');
    url.searchParams.set('attributes[Source]', 'Instant Eye Lift Funnel');
    url.searchParams.set('attributes[Offer]', selected.dataset.name);
    window.location.assign(url.toString());
  });
  window.addEventListener('pageshow', () => { checkout.disabled = false; checkout.textContent = 'CONTINUE TO SECURE CHECKOUT'; });

  const mainImage = $('[data-eye-main-image]');
  const gallery = $('[data-eye-gallery]');
  $$('[data-eye-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    $$('[data-eye-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    gallery.classList.add('is-switching');
    setTimeout(() => {
      mainImage.src = thumb.dataset.src;
      mainImage.alt = thumb.dataset.alt;
      gallery.classList.remove('is-switching');
    }, 140);
  }));

  const resultTrack = $('[data-eye-result-track]');
  const resultCards = $$('.eye-result-card', resultTrack);
  const resultDots = $('[data-eye-results-dots]');
  let resultIndex = 0;
  resultCards.forEach((_, index) => {
    const dot = document.createElement('i');
    if (index === 0) dot.classList.add('is-active');
    resultDots.appendChild(dot);
  });
  function goResult(index) {
    resultIndex = (index + resultCards.length) % resultCards.length;
    resultCards[resultIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    [...resultDots.children].forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === resultIndex));
  }
  $('[data-eye-results-prev]').addEventListener('click', () => goResult(resultIndex - 1));
  $('[data-eye-results-next]').addEventListener('click', () => goResult(resultIndex + 1));
  let resultTimer = setInterval(() => goResult(resultIndex + 1), 3600);
  const resultViewport = $('[data-eye-result-viewport]');
  resultViewport.addEventListener('pointerenter', () => clearInterval(resultTimer));
  resultViewport.addEventListener('pointerleave', () => { resultTimer = setInterval(() => goResult(resultIndex + 1), 3600); });

  const reviews = $$('.eye-review');
  let reviewIndex = 0;
  function goReview(index) {
    reviewIndex = (index + reviews.length) % reviews.length;
    reviews.forEach((review, itemIndex) => review.classList.toggle('is-active', itemIndex === reviewIndex));
    $('[data-eye-review-count]').textContent = `${String(reviewIndex + 1).padStart(2, '0')} / ${String(reviews.length).padStart(2, '0')}`;
  }
  $('[data-eye-review-prev]').addEventListener('click', () => goReview(reviewIndex - 1));
  $('[data-eye-review-next]').addEventListener('click', () => goReview(reviewIndex + 1));
  setInterval(() => goReview(reviewIndex + 1), 5200);

  const deadlineKey = 'eye-lift-sale-deadline-v1';
  let deadline = Number(sessionStorage.getItem(deadlineKey));
  if (!deadline || deadline <= Date.now()) {
    deadline = Date.now() + (2 * 60 * 60 * 1000);
    sessionStorage.setItem(deadlineKey, String(deadline));
  }
  function updateTimer() {
    const remaining = Math.max(0, deadline - Date.now());
    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    $('[data-eye-hours]').textContent = String(hours).padStart(2, '0');
    $('[data-eye-minutes]').textContent = String(minutes).padStart(2, '0');
    $('[data-eye-seconds]').textContent = String(seconds).padStart(2, '0');
  }
  updateTimer();
  setInterval(updateTimer, 1000);
})();
